// @flow
import React from 'react'

type Props = {
  htmlFor: string,
  text: string
}

const FormLabel = (props: Props): React$Element<'label'> => (
  <label className='form__label' htmlFor={props.htmlFor}>
    {props.text}
  </label>
)

export default FormLabel



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/FormLabel.js